import { useEffect, useRef, type MutableRefObject } from 'react';

export default function useMounted(): MutableRefObject<boolean> {
  const isMountedRef = useRef(true);

  useEffect(() => {
    if (!isMountedRef.current) {
      isMountedRef.current = true;
    }
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return isMountedRef;
}
